import { supabase } from '../supabase';

interface TaskerCategory {
  category_id: number;
  categories: {
    name: string;
  };
}

export const fetchTaskerCategories = async (taskerId: number): Promise<string[]> => {
  try {
    const { data, error } = await supabase
      .from('taskers_categories')
      .select(
        `
        category_id,
        categories(name)
      `
      )
      .eq('tasker_id', taskerId);

    if (error) throw error;

    console.log('Raw data from taskers_categories:', data);

    console.log('Sample item structure:', data?.[0]);

    const categories = (data as unknown as TaskerCategory[])
      ?.map((item) => item.categories.name)
      .filter(Boolean);

    return categories;
  } catch (error) {
    console.error('Error fetching tasker categories:', error);
    throw error;
  }
};

export const fetchTaskersCategoriesByTaskerIds = (taskerIds: number[]) => {
  return supabase
    .from('taskers_categories')
    .select(
      `
  *,
  categories (
    name
  )
`
    )
    .in('tasker_id', taskerIds);
};
